export const useCategoryStrings = () => {
  return {
    is_parent: 'Is Parent',
    category: 'Category',
    subcategory: 'Subcategory',
    production_id: 'Production ID',
  };
};
